import { useContext, useEffect, useRef } from "react";
import { LayoutStateContext } from "../../../contexts/layout_state";
import { useCssStateManager } from "../../../hooks/use_css_state_manager";
import { EventPane } from "../../core/event_pane";

export type CollectionSearchBarProps = {
    collectionId: string;
    collectionCaption: string;
};

export default function CollectionSearchBar({collectionId,collectionCaption}:CollectionSearchBarProps) {
    const { searchOpen,openSearch,searchBarCommRef,mobileDetect: { widthCutoff: mobileCutoff,miniWidthCutoff },collectionSearchBarOpen } = useContext(LayoutStateContext);

    const cssStateManager = useCssStateManager(["collection-search-bar"]);
    cssStateManager.useProperty(collectionSearchBarOpen.value,"open");
    cssStateManager.useProperty(searchOpen.value,"broader-search-open");    
    
    const { current: searchBarComm } = searchBarCommRef;

    const clickHandler = () => {
        if (!collectionSearchBarOpen.value) {
            collectionSearchBarOpen.value = true;
            openSearch("collection",collectionId);
        }
    };

    const placeholderRef = useRef<HTMLDivElement>();

    const placeholderTransitionEndHandler = (elem: HTMLDivElement,propertyName: string) => {
        if ((elem===placeholderRef.current) && (propertyName==="width") && (collectionSearchBarOpen.value)) {
            searchBarComm.notifyMeOnPlaceholderAnimationEnd();
        }
    };

    useEffect(() => {
        if ((!searchOpen.value) && (collectionSearchBarOpen.value)) {
            collectionSearchBarOpen.value = false;
        }
    },[searchOpen.value]);

    return (
        <>
            <div className={cssStateManager.getClassNames()}>
                <div ref={placeholderRef} className="placeholder" onTransitionEnd={(e) => placeholderTransitionEndHandler(e.target as HTMLDivElement,e.propertyName)}>
                    <div className="search-icon"><i className="icon-navbar-search" /></div>
                    <div className="placeholder-text">Search in {collectionCaption}</div>
                    <EventPane onClick={clickHandler} />
                </div>
            </div>
            <style jsx>{`
            .collection-search-bar {
                --duration: var(--search-open-duration);
                position: relative;
                z-index: 97;
            }

            .placeholder {
                width: 280rem;
                height: 40rem;
                border: 1rem solid #aaa;
                border-radius: 6rem;
                position: absolute;
                top: 0rem;
                right: 0rem;
                transition: width var(--duration);
                background-color: var(--body-background-color);
                overflow: hidden;
            }

            .open .placeholder {
                width: 520rem;
            }

            .search-icon {
                top: 6rem;
                color: #ccc;
                font-size: 21rem;
                position: absolute;
                left: 10rem;
            }

            .placeholder-text {
                color: #aaa;
                position: absolute;
                left: 40rem;
                top: 9rem;
                font-size: 15rem;            
                opacity: 1;
                visibility: visible;
                transition: opacity var(--duration),visibility var(--duration);
                width: 300rem;
            }

            .placeholder-text {
                white-space: no-wrap;
            }

            .open .placeholder-text {
                opacity: 0;
                visibility: hidden;
            }

            @media screen and (max-width: ${mobileCutoff}px) {
                .placeholder {
                    width: 0rem;                    
                    border: none;
                }               

                .open .placeholder {
                    border: 1rem solid #ddd;
                    width: 100%;
                }

                /*
                .placeholder-text {
                    display: none;
                }
                */

                .open .placeholder-text {
                    opacity: 1;
                    visibility: visible;
                }
            }

            @media screen and (max-width: ${miniWidthCutoff}px) {
                .placeholder-text {
                    font-size: 14rem;
                    top: 10rem;
                }
            }

            

            `}</style>
        </>
    );
}